import React, { useState } from "react";
import { FaEdit, FaChevronDown, FaChevronUp, FaEnvelope, FaPhoneAlt, FaCalendarAlt } from "react-icons/fa";
import UserProfileImg from "../../assets/image/userProfile.png";
import Input from "../../components/Input/Input";
import { enqueueSnackbar } from "notistack";
import "./ProfileView.css";

const CLASS_COLOR_COUNT = 4;

const ProfileView = ({ user, uploadProfileImageHandler }) => {
  const [expandedClassIndex, setExpandedClassIndex] = useState(0); // First item open by default

  const toggleAccordion = (index) => {
    setExpandedClassIndex(expandedClassIndex === index ? null : index);
  };

  const timeTableOpenHandler = () => {
    if (user.timetable_path) {
      window.open(user.timetable_path, "_blank");
    } else {
      enqueueSnackbar("TimeTable not uploaded", { variant: "error" });
    }
  };

  return (
    <div className="profile-container">
      {/* Left Side: User Information */}
      <div className="profile-left">
        <div className="profile-cover" />

        <div className="profile-avatar-wrap">
          <img
            src={user.profile_image || UserProfileImg}
            alt={`${user.name}'s avatar`}
            className="profile-avatar"
          />
          <label htmlFor="profileImageUpload" className="profile-edit-btn" title="Change photo">
            <FaEdit />
          </label>
          <div className="profile-avatar-upload">
            <Input
              id="profileImageUpload"
              type="file"
              name="profile_image"
              onChangeHandler={uploadProfileImageHandler}
            />
          </div>
        </div>

        <h1 className="profile-name">{user.name}</h1>
        {user.role_details?.name && (
          <span className="profile-role-badge">{user.role_details.name}</span>
        )}

        <div className="profile-contact-list">
          <div className="profile-contact-row">
            <span className="profile-contact-icon"><FaEnvelope /></span>
            <span>{user.email || "N/A"}</span>
          </div>
          <div className="profile-contact-row">
            <span className="profile-contact-icon"><FaPhoneAlt /></span>
            <span>{user.phone || "N/A"}</span>
          </div>
        </div>

        <button type="button" className="profile-timetable-btn" onClick={timeTableOpenHandler}>
          <FaCalendarAlt />
          <span>View TimeTable</span>
        </button>
      </div>

      {/* Right Side: Class and Subject Information */}
      <div className="profile-right">
        <h2 className="profile-section-title">Classes &amp; Subjects</h2>

        {user.programs && user.programs.length > 0 ? (
          user.programs.map((cls, index) => (
            <div key={index} className={`profile-class-card profile-class-c${index % CLASS_COLOR_COUNT}`}>
              <div className="profile-class-header" onClick={() => toggleAccordion(index)}>
                <span className="profile-class-title">{cls.class?.name || "No Class Name"}</span>
                {expandedClassIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </div>

              <div className={`profile-class-body ${expandedClassIndex === index ? "is-open" : ""}`}>
                {cls.subjects && cls.subjects.length > 0 ? (
                  cls.subjects.map((subject, idx) => (
                    <span key={idx} className="profile-subject-chip">{subject.name}</span>
                  ))
                ) : (
                  <span className="profile-no-subjects">No subjects assigned</span>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="text-muted">No programs assigned to this user.</p>
        )}
      </div>
    </div>
  );
};

export default ProfileView;
